export default "__VITE_ASSET__jbeqw5YZ__"